import { render, staticRenderFns } from "./BindsChips.vue?vue&type=template&id=ac63448c&"
import script from "./BindsChips.vue?vue&type=script&lang=js&"
export * from "./BindsChips.vue?vue&type=script&lang=js&"
import style0 from "./BindsChips.vue?vue&type=style&index=0&id=ac63448c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports